/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Refocus_Country_AriaInputs */

const bn_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিফোকাস দেশ`)
};

const de_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land neu ausrichten`)
};

const el_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επαναεστίαση της χώρας`)
};

const en_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refocus country`)
};

const es_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenfocar el país`)
};

const fr_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recentrer le pays`)
};

const hi_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`देश पर दोबारा ध्यान केंद्रित करें`)
};

const hu_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fókuszálja át az országot`)
};

const id_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokuskan kembali negara`)
};

const it_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rifocalizzare il paese`)
};

const ja_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`国に焦点を当て直す`)
};

const ko_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다시 초점을 맞춘 국가`)
};

const nl_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heroriënteer het land`)
};

const pl_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmień ostrość kraju`)
};

const pt_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reorientar o país`)
};

const ru_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переориентация страны`)
};

const sv_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokusera om landet`)
};

const tr_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ülkeye yeniden odaklan`)
};

const uk_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перефокусувати країну`)
};

const vi_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tập trung lại quốc gia`)
};

const zh_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新聚焦国家`)
};

const zh_hant_game_refocus_country_aria = /** @type {(inputs: Game_Refocus_Country_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新聚焦國家`)
};

/**
* | output |
* | --- |
* | "Refocus country" |
*
* @param {Game_Refocus_Country_AriaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_refocus_country_aria = /** @type {((inputs?: Game_Refocus_Country_AriaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Refocus_Country_AriaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_refocus_country_aria(inputs)
	if (locale === "de") return de_game_refocus_country_aria(inputs)
	if (locale === "el") return el_game_refocus_country_aria(inputs)
	if (locale === "en") return en_game_refocus_country_aria(inputs)
	if (locale === "es") return es_game_refocus_country_aria(inputs)
	if (locale === "fr") return fr_game_refocus_country_aria(inputs)
	if (locale === "hi") return hi_game_refocus_country_aria(inputs)
	if (locale === "hu") return hu_game_refocus_country_aria(inputs)
	if (locale === "id") return id_game_refocus_country_aria(inputs)
	if (locale === "it") return it_game_refocus_country_aria(inputs)
	if (locale === "ja") return ja_game_refocus_country_aria(inputs)
	if (locale === "ko") return ko_game_refocus_country_aria(inputs)
	if (locale === "nl") return nl_game_refocus_country_aria(inputs)
	if (locale === "pl") return pl_game_refocus_country_aria(inputs)
	if (locale === "pt") return pt_game_refocus_country_aria(inputs)
	if (locale === "ru") return ru_game_refocus_country_aria(inputs)
	if (locale === "sv") return sv_game_refocus_country_aria(inputs)
	if (locale === "tr") return tr_game_refocus_country_aria(inputs)
	if (locale === "uk") return uk_game_refocus_country_aria(inputs)
	if (locale === "vi") return vi_game_refocus_country_aria(inputs)
	if (locale === "zh") return zh_game_refocus_country_aria(inputs)
	return zh_hant_game_refocus_country_aria(inputs)
});